import { createFileRoute } from '@tanstack/react-router'
import {
  FormTemplateTag,
  FormTemplateType,
  PaginatedListSortOrder,
  TemplateListSortCriteria,
  TemplateListStatusFilter,
} from 'siteline-common-all/enums'
import { z } from 'zod'
import { looseArray, looseString } from '../common/util/SearchParams'
import FormTemplateList from '../components/form-template-list/FormTemplateList'

const searchSchema = z.object({
  status: z.enum(TemplateListStatusFilter).optional(),
  sortCriteria: z.enum(TemplateListSortCriteria).optional(),
  sortOrder: z.enum(PaginatedListSortOrder).optional(),
  assigneeId: looseString.optional(),
  waitingOnId: looseString.optional(),
  relatedCompanyId: looseString.optional(),
  type: z.enum(FormTemplateType).optional(),
  tags: looseArray(z.enum(FormTemplateTag)).optional(),
  associatedContractId: looseString.optional(),
  isUnused: z.boolean().optional(),

  // Sentinel written by "Clear filters" so reloading a cleared URL doesn't re-apply default filters
  filters: z.literal('none').optional(),
})

export type FormTemplateListSearch = z.infer<typeof searchSchema>

export const Route = createFileRoute('/_a/templates/')({
  component: FormTemplateList,
  validateSearch: searchSchema,
})
